import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    absolute: "",
    color: "white",
    "elevate-on-scroll": "",
    class: "pa-0",
    elevation: "0",
    rounded: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "2",
            class: "d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.backBtnList[_ctx.$router.currentRoute.value.name])
                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                    key: 0,
                    style: {"pointer-events":"auto"},
                    color: "secondary",
                    onClick: _withModifiers(_ctx.onBack, ["stop"]),
                    icon: "$oss-chevron-left"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "8",
            class: "d-flex align-center pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                placeholder: "Entreprise sélectionnée",
                modelValue: _ctx.selectedCompanyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompanyName) = $event)),
                readonly: "",
                "hide-details": "",
                class: "oss-bordered bordered-large",
                "data-cy": "index-selectCompany",
                style: _normalizeStyle(_ctx.topButtonStyle),
                onClick: _ctx.onCompanySelectClick
              }, null, 8, ["modelValue", "style", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "rounded-bl-lg d-flex align-center justify-end pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_icon, {
                icon: "$oss-outlined-user",
                style: _normalizeStyle(_ctx.topButtonStyle),
                onClick: _ctx.onUserBtnClick,
                "data-cy": "index-showUserProfile"
              }, null, 8, ["style", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}